import { createContext, useState } from 'react'
import { WithChildren } from '_metronic/helpers'

interface IContext {
  isOpenImportProjectModal: boolean
  toggleImportProjectModal: (isOpen: boolean) => void
}

export const ProjectListViewContext = createContext<IContext>({
  isOpenImportProjectModal: false,
  toggleImportProjectModal: () => {},
})

export const ProjectListViewContextProvider: React.FC<WithChildren> = ({ children }) => {
  const [isOpenImportProjectModal, setIsOpenImportProjectModal] = useState(false)

  const toggleImportProjectModal = (isOpen: boolean) => {
    setIsOpenImportProjectModal(isOpen)
  }

  return (
    <ProjectListViewContext.Provider
      value={{
        isOpenImportProjectModal,
        toggleImportProjectModal,
      }}>
      {children}
    </ProjectListViewContext.Provider>
  )
}
